// src/customer/customer-policy/customer-policy-commission/CommissionReconciliation.tsx

import React, { useState } from "react";
import { ITableColumn, DataTableDefaultCellTemplates, DataTableEventArgs } from "../../../components";
import DataTable from "../../../components/components/Table/DataTable";
import ReconcileSummary from "./ReconcileSummary";
import TransactionGroupContent from "./TransactionGroup";
import { ICommissionTransactionGroup } from "./models/CommissionTypes";
import { mockCommissionData } from "./models/CommissionMockData";
import "./CommissionReconciliation.scss";

const CommissionReconciliation: React.FC = () => {
  const { summary, transactionGroups } = mockCommissionData;
  const [expandedRowId, setExpandedRowId] = useState<string | null>(
    transactionGroups.length > 0 ? transactionGroups[0].transactionDate : null
  );

  const onRowClick = (rowData: ICommissionTransactionGroup) => {
    if (expandedRowId === rowData.transactionDate) {
      setExpandedRowId(null);
    } else {
      setExpandedRowId(rowData.transactionDate);
    }
  };

  const renderRow = (group: ICommissionTransactionGroup, _index: number) => {
    return (
      <React.Fragment key={group.transactionDate}>
        {expandedRowId === group.transactionDate && (
          <tr>
            <td colSpan={tableColumns.length}>
              <TransactionGroupContent group={group} />
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  };

  const tableColumns: ITableColumn[] = [
    {
      // ITableColumn.width — matches PolicyTransactionPremiumService / CustomerPolicyLocationService pattern
      width: "40px",
      cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
      cellClickHandler: (dtEventArgs: DataTableEventArgs) => {
        onRowClick(dtEventArgs.rowData);
      },
      onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
        const { eventData, rowData } = dtEventArgs;
        if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
          onRowClick(rowData);
        }
      },
      cellTdClassName: "expander-cell-td",
    },
    {
      header: "Transaction Date",
      field: "transactionDate",
      cellTemplate: (rowData: ICommissionTransactionGroup) => (
        <span className="fw-bold">Transaction {rowData.transactionDate}</span>
      ),
    },
  ];

  return (
    <div className="py-3">
      <ReconcileSummary data={summary} />

      <div className="commission-columns-header">
        <div className="fw-bold">Direct Bill Records</div>
        <div className="fw-bold">Commission Report</div>
      </div>

      <DataTable
        columns={tableColumns}
        data={transactionGroups}
        keyColumnName="transactionDate"
        expandedRowId={expandedRowId}
        setExpandedRowId={setExpandedRowId}
        renderRow={renderRow}
        tableClassName="table-striped table-hover table-sm"
        theadClassName="tblHeader"
      />
    </div>
  );
};

export default CommissionReconciliation;
